import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {history} from 'fn-common-ui';
import {ButterBar} from '../components/alert-message/butter-bar';

const SUBJECT_MAX_LENGTH = 250;
const MESSAGE_MAX_LENGTH = 10000;

@inject('store')
@observer
export default class FeedbackPage extends React.Component {

  static propTypes = {
    store: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.feedbackStore = this.props.store.feedbackStore;
  }

  componentWillUnmount() {
    if (this.feedbackStore.formHasEntries && !this.feedbackStore.hasBeenSubmitted) {
      this.feedbackStore.toggleExitModal();
      history.goBack();
    }
    if (this.feedbackStore.hasBeenSubmitted) {
      this.feedbackStore.toggleHasBeenSubmitted();
    }
    this.feedbackStore.clearFeedbackForm();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.feedbackStore.submitForm(e.target);
  }

  handleOnChange = (e, num) => {
    e.preventDefault();
    this.feedbackStore.changeValue(e.target, num);
  }

  handleOnBlur = (e) => {
    e.preventDefault();
    this.feedbackStore.validateInput(e.target);
  }

  toggleExitModal = (e) => {
    e.preventDefault();
    this.feedbackStore.toggleExitModal()
  }

  toggleAlertBar = (e) => {
    e.preventDefault();
    this.feedbackStore.toggleAlertBar();
  }

  discardFormChanges = (e) => {
    e.preventDefault();
    this.feedbackStore.toggleExitModal(false)
    this.feedbackStore.clearFeedbackForm();
    if (this.feedbackStore.hasBeenSubmitted) {
      this.feedbackStore.toggleHasBeenSubmitted();
    }
    history.replace('/');
  }

  renderExitModal = () => {
    if (!this.feedbackStore.showExitModal) return null;
    return (
      <div className="modal-wrapper">
        <div className="modal fade show" style={{display: 'block'}} role="dialog" aria-modal="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button type="button" className="fn-modal-close" onClick={this.toggleExitModal}>
                <i aria-hidden="true" className="icon-close"></i>
                <span className="sr-only">Close window</span>
              </button>
              <div className="modal-header text-center">
                <h1 className="as-h2 modal-title">
                  Unsaved changes
                </h1>
              </div>
              <div className="modal-body text-center">
                <p>Your form changes will not be saved if you navigate away from this page.</p>
              </div>
              <div className="row no-gutters modal-actions text-center">
                <button className='fn-primary' onClick={this.toggleExitModal}>Stay on Page</button>
                <button className='fn-secondary' onClick={this.discardFormChanges}>Discard Changes</button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </div>)
  }

  renderSuccessPage = () => {
    return (<div>
      <div id="customer-feedback-success">
        <div className="success-content">
          <h1>Thank you.</h1>
          <p>Your message has been received.</p>
          <button className='fn-primary' onClick={this.discardFormChanges}>Return Home</button>
        </div>
      </div>
    </div>)
  }

  renderFeedbackForm = () => {
    const subjectHasError = this.feedbackStore.hasErrors.feedback_subject || this.feedbackStore.feedbackObject.feedback_subject.length >= SUBJECT_MAX_LENGTH;
    const categoryHasError = this.feedbackStore.hasErrors.feedback_category
    const messageHasError = this.feedbackStore.hasErrors.feedback_message || this.feedbackStore.feedbackObject.feedback_message.length >= MESSAGE_MAX_LENGTH;
    return (<section className='content-wrapper'>
      <div className='container'>
        <div className='row text-center'>
          <div className='offset-1 col-10 offset-md-2 col-md-8 offset-lg-3 col-lg-6'>
            <h1>Contact Us</h1>
          </div>
        </div>
        <div className='row'>
          <section className="offset-1 col-10 offset-md-2 col-md-8 offset-lg-3 col-lg-6">
            <form className="feedback-form" noValidate="noValidate" onSubmit={this.handleSubmit}>
              {this.feedbackStore.showAlertBar &&
                <ButterBar type="error" message="<strong>Error:</strong> Please correct the errors below." handleCloseClick={this.toggleAlertBar} />}

              <div className={`form-group ${subjectHasError
                  ? 'has-error'
                  : ''}`}>
                <label className='col-form-label' htmlFor='feedback_subject'>
                  Subject<span className='required-asterisks'>*</span>
                  <span className="help-text">Max {SUBJECT_MAX_LENGTH} characters.</span>
                  <div className="msgBlock error-list" aria-live="polite">
                    <span>
                      {this.feedbackStore.hasErrors.feedback_subject ? 'Please enter a subject.' : ''}
                    </span>
                    <span >
                      {this.feedbackStore.feedbackObject.feedback_subject.length >= SUBJECT_MAX_LENGTH ? 'Character limit reached.' : ''}
                    </span>
                  </div>
                </label>
                <input type='text' id='feedback_subject' className='form-control input-lg' value={this.feedbackStore.feedbackObject.feedback_subject} onChange={(e) => this.handleOnChange(e, SUBJECT_MAX_LENGTH)} onBlur={this.handleOnBlur}/>
              </div>

              <div className={`form-group ${categoryHasError
                  ? 'has-error'
                  : ''}`}>
                <label className='col-form-label' htmlFor='feedback_category'>
                  Category<span className='required-asterisks'>*</span>
                  <div className="msgBlock error-list" aria-live="polite">
                    <span>
                      {this.feedbackStore.hasErrors.feedback_category ? 'Please select a category.' : ''}
                    </span>
                  </div>
                </label>

                <select id='feedback_category' className='form-control form-control-lg' value={this.feedbackStore.feedbackObject.feedback_category} onChange={(e) => this.handleOnChange(e, MESSAGE_MAX_LENGTH)} onBlur={this.handleOnBlur}>
                  <option value='' hidden="hidden">Select Category</option>
                  <option value='Pre-Submission'>Pre-Submission</option>
                  <option value='FirstNet App Review Process'>FirstNet App Review Process</option>
                  <option value='Live Apps'>Live Apps</option>
                  <option value='Performance'>Performance</option>
                  <option value='General Feedback'>General Feedback</option>
                  <option value='General Inquiries'>General Inquiries</option>
                  <option value='Other'>Other</option>
                </select>
              </div>

              <div className={`form-group ${messageHasError
                  ? 'has-error'
                  : ''}`}>
                <label className="col-form-label" htmlFor="feedback_message">
                  Message<span className="required-asterisks">*</span>
                  <span className="help-text">Max {MESSAGE_MAX_LENGTH.toLocaleString()} characters.</span>
                  <div className="msgBlock error-list" aria-live="polite">
                    <span>
                      {this.feedbackStore.hasErrors.feedback_message ? 'Please enter a message.' : ''}
                    </span>
                    <span>
                      {this.feedbackStore.feedbackObject.feedback_message.length >= MESSAGE_MAX_LENGTH ? 'Character limit reached.' : ''}
                    </span>
                  </div>
                </label>
                <textarea type="text" id="feedback_message" className="form-control" rows="7" value={this.feedbackStore.feedbackObject.feedback_message} onChange={(e) => this.handleOnChange(e, MESSAGE_MAX_LENGTH)} onBlur={this.handleOnBlur}/>
              </div>

              <div className="form-group text-center">
                {/* Allow user to tab to and click this button when disabled, to allow error display and audio */}
                <button type="submit" className="fn-primary" aria-disabled={!this.feedbackStore.requiredFieldsEntered}>
                  Submit
                </button>
              </div>

            </form>
          </section>
        </div>
      </div>
    </section>)
  }

  render() {
    return (<article id='customer-feedback-page'>
      {
        this.feedbackStore.hasBeenSubmitted
          ? this.renderSuccessPage()
          : this.renderFeedbackForm()
      }
      {this.renderExitModal()}
    </article>)
  }
}
